import { Page } from '.';

export class Pod {
  name: string;
  hide: boolean;
  description: string;
  image: string;
  status: string;
  hideTitle: boolean;
  firebaseUrl: string = '';
  targetType: string;
  targetUrl: URL;
  targetID: string;
  targetPage: Page;

  testID: string = '';

  constructor(json: any) {
    this.name = json.name || '';
    this.hide = json.hide;
    this.description = json.description || '';
    this.image = json.image;
    this.targetType = json.target || json.targetType;
    if(this.targetType === 'page') {
      this.targetID = json.target_page || json.targetID;
    }
    if(this.targetType === 'external') {
      this.targetUrl = json.target_url || '';
    }
    this.status = json.status || '';
    this.hideTitle = json.hide_title || '';
    this.firebaseUrl = '/' + json.$key;

    this.generateDynamicId();
  }

  toFirebaseObject() : any {
    let obj: any = {};

    if (this.name) obj.name = this.name;
    if (this.hide) obj.hide = this.hide;
    if (this.status) obj.status = this.status || 'hidden';
    if (this.image) obj.image = this.image || '';
    if (this.hideTitle) obj.hide_title = this.hideTitle;
    if (this.description) obj.description = this.description;
    if (this.firebaseUrl) obj.firebase_url = this.firebaseUrl;
    if (this.targetType) {
      obj.target = this.targetType;
      if(this.targetType === 'page' && this.targetID) {
        obj.target_page = this.targetID;
      }
      if(this.targetType === 'external' && this.targetUrl) {
        obj.target_url = this.targetUrl;
      }
    }

    return obj;
  }

  generateDynamicId() {
    let validId = this.name;
    validId = validId.replace(/\s+/g, '-');
    validId = validId.replace(/[^a-z0-9\-_\.]|^[^a-z0-9]+/gi, '');
    this.testID = 'home-' + validId;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/pod.model.ts